import { render, staticRenderFns } from "./datasort.vue?vue&type=template&id=d230c822&scoped=true&"
import script from "./datasort.vue?vue&type=script&lang=js&"
export * from "./datasort.vue?vue&type=script&lang=js&"
import style0 from "./datasort.vue?vue&type=style&index=0&id=d230c822&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d230c822",
  null
  
)

export default component.exports